module.exports = "<p>נשמח לענות :) תוכלו לשאול אותנו על ידי השארת הודעה בעמוד &quot;צור קשר&quot;, שתמצאו בתחתית האתר. אנחנו כבר נחזור אליכם עם התשובה.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/15.md
// module id = 805
// module chunks = 0